import "./styles/About.css";
import resume from "./data/Shahbin_Hossain_Resume.pdf";
import React, { useState, useEffect } from "react";
import contactData from "./data/contactData";

const About = () => {
  const [componentHeight, setComponentHeight] = useState(0);

  useEffect(() => {
    const component1 = document.querySelector("#nav-app-bar");
    if (component1) {
      setComponentHeight(component1.offsetHeight);
    }
  }, []);

  const handleOnClick = (link) => {
    window.open(link, "_blank");
  };

  return (
    <div id="about" className="section">
      <div
        id="about-section"
        style={{
          height: `calc(100vh - ${componentHeight}px)`,
          marginTop: `calc(${componentHeight}px)`,
        }}
      >
        <div id="about-left-column">
          <div>
            <h1 id="about-h">Shahbin Hossain</h1>
            <p id="about-p">
              I'm a developer focused on building clean, responsive, and reliable web and app experiences.<br />
              Welcome to my portfolio site {"=]"}<br />
            </p>
            <p id="about-p" style={{color: "blueviolet" }}>P.S: I have <span style={{color: "black" }} id="demos-button" onClick={() => window.location.href = "https://shahos348.github.io/demos"}>Demos➚</span></p>
            
          </div>

          <div id="resume-contact-row">
            <a
              id="resume-button"
              href={resume}
              target="_blank"
              rel="noopener noreferrer"
            >
              Resume
            </a>

            <div id="contact-icons-inline">
              {contactData.map((contact) => (
                <img
                  key={contact.id}
                  src={contact.image}
                  alt={contact.name}
                  title={contact.name}
                  className="contact-icon-inline"
                  onClick={() => handleOnClick(contact.link)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;